import { FilterFieldInstruction, applyOptionsDynamicDirectives, optionsInputDefaults, optionsInputMap } from './shared';
export class FilterDropdownInstruction extends FilterFieldInstruction {
  getDefaults() {
    return {
      ...optionsInputDefaults,
      showClear: false,
      placeholder: 'Bitte wählen...',
      inline: true
    };
  }
  constructor(config) {
    super();
    /** object map of input name -> source name / function */
    this.inputMap = {
      ...optionsInputMap,
      showClear: 'showClear',
      placeholder: 'placeholder',
      inline: 'inline'
    };
    this.attributeMap = {
      'e2e-filter': 'formControlName'
    };
    this.setConfig(config);
    this.addDirectivesPlugin(applyOptionsDynamicDirectives);
  }
  load() {
    return import(/* webpackChunkName: "ui-input-dropdown" */
    /* webpackMode: "lazy" */
    '@common/ui/frontend-shared/input-dropdown').then(m => m.UiInputDropdownComponent);
  }
}